import { useMutation } from "@tanstack/react-query";
import PaymentService from "../services";

const useDeleteCard = () => {
  return useMutation({
    mutationFn: (paymentMethodId: string) => PaymentService.delete(paymentMethodId), // Assuming delete API takes an ID
    onSuccess: () => {
    },
    onError: (error) => {
      console.error("Error deleting card:", error);
    },
  });
};

export default useDeleteCard;
